module.exports = "<p>\n  company-event-quick-view-page works!\n</p>\n"